'use client';

import React from 'react';
import classNames from 'classnames';
import { useRouter } from 'next/navigation';

interface TimelineSidebarProps {
  selectedIndex: number;
  colorText?: string | null;
}

export default function TimelineSidebar({
  selectedIndex,
  colorText,
}: TimelineSidebarProps) {
  const router = useRouter();

  const items = [
    {
      label: 'Our Simplicity\n Partner Network',
      href: '/partners/partner-network',
    },
    {
      label: 'Our Channel Partner\n Programs',
      href: '/partners/channel-partner-programs',
    },
    { label: 'Preferred VAR', href: '/partners/preferred-var' },
    { label: 'Authorised VAR', href: '/partners/authorised-var' },
    { label: 'Exclusive VAR', href: '/partners/exclusive-var' },
    {
      label: 'Professional Services\n Providers',
      href: '/partners/professional-services-providers',
    },
  ];

  const handleClick = (href: string) => {
    router.push(href);
  };

  return (
    <div className="w-[220px] flex flex-col py-10">
      <ul role="list">
        {items.map((item, idx) => {
          const isActive = idx === selectedIndex;

          return (
            <li key={idx}>
              <div className="relative pb-8">
                {idx !== items.length - 1 && (
                  <span
                    className="absolute left-2 top-4 -ml-px h-full w-0.5 bg-gray-400"
                    aria-hidden="true"
                  />
                )}
                <span
                  className={classNames(
                    'relative flex items-start gap-3 cursor-pointer group transition-all duration-300 ease-in-out'
                  )}
                  onClick={() => handleClick(item.href)}
                >
                  {/* Dot */}
                  <span
                    className={classNames(
                      'flex-none h-4 w-4 mt-1 items-center justify-center rounded-full ring-2 transition-all duration-300',
                      isActive
                        ? 'bg-[#BF984D] ring-[#BF984D]'
                        : 'bg-white ring-gray-400 group-hover:ring-[#BF984D] group-hover:bg-[#f8e8c4]'
                    )}
                  ></span>

                  {/* Label */}
                  <span
                    className={classNames(
                      'text-sm leading-snug transition-all duration-300 transform group-hover:scale-[1.02] whitespace-pre-line',
                      isActive ? 'font-medium' : '',
                      colorText
                        ? 'text-white'
                        : isActive
                          ? 'text-black'
                          : 'text-gray-600 group-hover:text-black'
                    )}
                  >
                    {item.label}
                  </span>
                </span>
              </div>
            </li>
          );
        })}
      </ul>
    </div>
  );
}
